/**
* Copyright Zendesk, Inc.
*
* Use of this source code is governed under the Apache License, Version 2.0
* found at http://www.apache.org/licenses/LICENSE-2.0.
*/
import styled, { css } from 'styled-components';
import { SELECTOR_FOCUS_VISIBLE, retrieveComponentStyles, DEFAULT_THEME, focusStyles, getColorV8 } from '@zendeskgarden/react-theming';
import { StyledTextInput } from './StyledTextInput.js';
import { StyledTextMediaFigure } from './StyledTextMediaFigure.js';

const COMPONENT_ID = 'forms.faux_input';
const VALIDATION_HUES = {
  success: 'successHue',
  warning: 'warningHue',
  error: 'dangerHue'
};
function getValidationHue(validation) {
  let defaultHue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'primaryHue';
  if (validation) {
    return VALIDATION_HUES[validation];
  }
  return defaultHue;
}
const colorStyles = props => {
  const {
    theme,
    validation,
    focusInset,
    isBare,
    isFocused
  } = props;
  return css(["", ""], focusStyles({
    theme,
    inset: focusInset,
    condition: !isBare,
    hue: getValidationHue(validation),
    shade: validation === 'warning' ? 700 : 600,
    selector: isFocused ? '&' : '&:focus-within',
    styles: {
      borderColor: getColorV8(getValidationHue(validation), 600, theme)
    }
  }));
};
const StyledTextFauxInput = styled(StyledTextInput).attrs(props => ({
  as: 'div',
  'aria-readonly': props.isReadOnly,
  'aria-disabled': props.isDisabled,
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': '8.76.9'
})).withConfig({
  displayName: "StyledTextFauxInput",
  componentId: "sc-yqw7j9-0"
})(["display:", ";align-items:", ";cursor:", ";overflow:hidden;", " & > ", "{vertical-align:", ";", "{box-shadow:unset;}}& > ", "{flex-shrink:", ";}", ";"], props => props.mediaLayout ? 'inline-flex' : 'inline-block', props => props.mediaLayout && 'baseline', props => props.mediaLayout && !props.isDisabled ? 'text' : 'default', colorStyles, StyledTextInput, props => !props.mediaLayout && 'baseline', SELECTOR_FOCUS_VISIBLE, StyledTextMediaFigure, props => props.mediaLayout && '0', props => retrieveComponentStyles(COMPONENT_ID, props));
StyledTextFauxInput.defaultProps = {
  theme: DEFAULT_THEME
};

export { StyledTextFauxInput, getValidationHue };
